export default "__VITE_ASSET__BbLXgAfZ__"